/**
 * The current version, in semver.
 * @type {String}
 */
export const VERSION = "0.11.5";
